/* artvision® · Stimmen-Karussell · endlos
   Die Karten werden vorne und hinten einmal geklont. Läuft die Spur in
   einen Klon-Bereich, springt sie unsichtbar auf die gleiche Position
   im Original zurück – so geht es in beide Richtungen ohne Ende weiter.
   Pfeile blättern um eine sichtbare Seite, Punkte zeigen die Seite.
   Ohne JS bleibt die Spur wischbar. */
(function () {
  function init(root) {
    if (root.dataset.avVoicesReady) return;
    root.dataset.avVoicesReady = '1';

    var track = root.querySelector('[data-av-voices-track]');
    var prev = root.querySelector('[data-av-voices-prev]');
    var next = root.querySelector('[data-av-voices-next]');
    var dotsWrap = root.querySelector('[data-av-voices-dots]');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    var count = originals.length;
    if (!count) return;

    function perView() {
      var v = parseFloat(getComputedStyle(track).getPropertyValue('--av-voices-per'));
      return v > 0 ? v : 1;
    }

    // Nur endlos, wenn mehr Karten als sichtbar sind
    var looping = count > Math.floor(perView());
    var firstOriginal = originals[0];
    var firstAfter = null;

    function makeClone(el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('inert', '');
      c.classList.add('av-voices__slide--clone');
      c.removeAttribute('data-shopify-editor-block');
      return c;
    }

    if (looping) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (el) { before.appendChild(makeClone(el)); after.appendChild(makeClone(el)); });
      firstAfter = after.firstChild;
      track.insertBefore(before, firstOriginal);
      track.appendChild(after);
    }

    function setStart() { return looping ? firstOriginal.offsetLeft - track.firstElementChild.offsetLeft : 0; }
    function setWidth() { return looping ? firstAfter.offsetLeft - firstOriginal.offsetLeft : track.scrollWidth; }
    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return (firstOriginal.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(perView()));
    }
    function pages() { return Math.max(1, Math.ceil(count / Math.max(1, Math.floor(perView())))); }

    function jumpTo(left) {
      var sb = track.style.scrollBehavior, st = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      // Snap erst nach dem Sprung wieder zulassen
      requestAnimationFrame(function () {
        track.style.scrollSnapType = st;
        track.style.scrollBehavior = sb;
      });
    }

    function normalise() {
      if (!looping) return;
      var start = setStart(), w = setWidth(), x = track.scrollLeft;
      if (x < start - 2) jumpTo(x + w);
      else if (x >= start + w - 2) jumpTo(x - w);
    }

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var d = document.createElement('span');
        d.className = 'av-voices__dot';
        dotsWrap.appendChild(d);
      }
      update();
    }

    // Aktive Seite: bei Klick sofort gesetzt, beim Wischen live aus der Position
    var current = 0;
    var animating = false;

    function indexFromPosition() {
      var n = pages();
      var w = setWidth();
      var rel = track.scrollLeft - setStart();
      if (looping) rel = ((rel % w) + w) % w;
      return Math.round(rel / (step() || 1)) % n;
    }

    function paintDots(c) {
      current = c;
      if (!dotsWrap) return;
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
        d.classList.toggle('is-active', i === c);
      });
    }

    function update() {
      var n = pages();
      if (!animating) paintDots(indexFromPosition());
      if (!looping) {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      root.classList.toggle('av-voices--static', !looping && n <= 1);
    }

    function go(dir) {
      normalise();
      var n = pages();
      // Punkt sofort mitziehen, nicht erst nach Ende der Animation
      paintDots(((current + dir) % n + n) % n);
      animating = true;
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    var t, raf;
    function settle() { animating = false; normalise(); update(); }
    track.addEventListener('scroll', function () {
      // Beim Wischen live nachführen
      if (!animating && !raf) {
        raf = requestAnimationFrame(function () { raf = null; update(); });
      }
      clearTimeout(t);
      t = setTimeout(settle, 140);
    }, { passive: true });
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', function () { clearTimeout(t); settle(); });
    }

    window.addEventListener('resize', function () {
      jumpTo(setStart());
      renderDots();
    });

    jumpTo(setStart());
    renderDots();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-av-voices]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
